var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupReservations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 80",
    style: {
      enableBackground: "new 0 0 64 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#1DB771;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.1,11h-16c-2.8,0-5,2.2-5,5v32c0,2.8,2.2,5,5,5h16c2.8,0,5-2.2,5-5V16C45.1,13.2,42.8,11,40.1,11z M43.1,48  c0,1.7-1.3,3-3,3h-16c-1.7,0-3-1.3-3-3V16c0-1.7,1.3-3,3-3h16c1.7,0,3,1.3,3,3V48z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.1,9c2.2,0,4-1.8,4-4s-1.8-4-4-4s-4,1.8-4,4S29.9,9,32.1,9z M32.1,3c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2  S31,3,32.1,3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.1,22c2.2,0,4-1.8,4-4s-1.8-4-4-4s-4,1.8-4,4S48.9,22,51.1,22z M51.1,16c1.1,0,2,0.9,2,2s-0.9,2-2,2  s-2-0.9-2-2S50,16,51.1,16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.1,28c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S53.3,28,51.1,28z M51.1,34c-1.1,0-2-0.9-2-2s0.9-2,2-2  s2,0.9,2,2S52.2,34,51.1,34z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.1,42c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S53.3,42,51.1,42z M51.1,48c-1.1,0-2-0.9-2-2s0.9-2,2-2  s2,0.9,2,2S52.2,48,51.1,48z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.1,14c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S15.3,14,13.1,14z M13.1,20c-1.1,0-2-0.9-2-2s0.9-2,2-2  s2,0.9,2,2S14.2,20,13.1,20z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.1,28c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S15.3,28,13.1,28z M13.1,34c-1.1,0-2-0.9-2-2s0.9-2,2-2  s2,0.9,2,2S14.2,34,13.1,34z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.1,42c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S15.3,42,13.1,42z M13.1,48c-1.1,0-2-0.9-2-2s0.9-2,2-2  s2,0.9,2,2S14.2,48,13.1,48z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.1,55c-2.2,0-4,1.8-4,4s1.8,4,4,4s4-1.8,4-4S34.3,55,32.1,55z M32.1,61c-1.1,0-2-0.9-2-2s0.9-2,2-2  s2,0.9,2,2S33.2,61,32.1,61z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.1,25h-5v2h4v9h-14v-9h4v-2h-5c-0.6,0-1,0.4-1,1v11c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1V26  C41.1,25.4,40.6,25,40.1,25z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.4,30.7l3,3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l3-3l-1.4-1.4l-1.3,1.3V20h-2v10.6l-1.3-1.3L28.4,30.7z  "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupReservations);
export default __webpack_public_path__ + "static/media/Group-Reservations.69c4ccb262a28adf02eeef83848503d3.svg";
export { ForwardRef as ReactComponent };